export default {
  sui: {
    loading: {
      text: '読み込み中'
    },
    form: {
      more: 'もっと見る',
      zhankai: 'もっと見る',
      shouqi: '隠す',
      query: '検索',
      reset: 'リセット',
      add: '追加',
      update: '更新',
      delete: '削除',
      required: 'は必須です',
      export: {
        export: 'エクスポート',
        selectFormat: 'フォーマットを選択',
        selectedRow: '{key}行が選択されました',
        selectedTotal: '合計{key}行、エクスポート',
        line: '行'
      },
      please: {
        input: '入力してください ',
        select: '選択してください '
      },
      time: {
        start: '開始時間',
        end: '終了時間',
        to: 'から'
      },
      date: {
        start: '開始日',
        end: '終了日'
      },
      upload: {
        triggerText: 'アップロード'
      },
      expand: '展開',
      multiple: '複数選択',
      cols_hide: 'ヘッダー設定'
    },
    table: {
      handle: '操作',
      sum: '合計',
      index: 'インデックス',
      zanwushuju: 'データなし',
      queding: 'OK',
      quxiao: 'キャンセル',
      lie: '列',
      yiyincang: '非表示',
      gong: '合計'
    },
    tableEdit: {
      tip1: 'データは編集中のため保存できません！',
      tip2: 'データを削除してもよろしいですか？',
      baocun: '保存',
      chongzhi: 'リセット',
      xinzeng: '追加',
      guanbituozhuai: 'ドラッグを無効化',
      kaiqituozhuai: 'ドラッグを有効化',
      caozuo: '操作',
      queren: '確認',
      bianji: '編集',
      shanchu: '削除',
      tishi: 'ヒント'
    },
    list: {
      yi_xuan_ze: '選択済み',
      tiao: '件',
      gong: '合計',
      mei_you_geng_duo: 'これ以上ありません',
      zan_wu_shu_ju: 'まだデータが選択されていません'
    },
    bond: {
      zheng_quan_dai_ma: '債券コード',
      zheng_quan_ming_cheng: '債券名',
      zan_wu_shu_ju: 'データなし',
      qu_xiao_qing_qiu: 'リクエストがキャンセルされました'
    },
    dialog: {
      ok: '確認',
      cancel: 'キャンセル'
    },
    page: {
      add: {
        success: '[{key}]の追加に成功しました'
      },
      delete: {
        title: '{key}-削除',
        confirm: '[{key}]を削除してもよろしいですか？',
        success: '[{key}]の削除に成功しました'
      },
      update: {
        success: '[{key}]の更新に成功しました',
        noChange: 'データに変更がないため、保存されません'
      }
    },
    tablePage: {
      export: {
        tip1: '正しい行番号を入力してください',
        tip2: 'エクスポートタイプ',
        tip3: '選択',
        tip4: 'としてエクスポート',
        tip5: 'エクスポートファイルタイプを選択してください',
        lie: '列',
        hang: '行',
        shi: 'はい',
        fou: 'いいえ',
        daochu: 'エクスポート',
        wancheng: '確認',
        quxiao: 'キャンセル',
        gong: '合計',
        type1: '連続エクスポート',
        type2: '手動選択エクスポート',
        daochu_geshi: 'エクスポートファイル形式'
      }
    },
    editlist: {
      caozuo: '操作',
      shanchu: '削除',
      xinzeng: '追加'
    },
    upload: {
      tip1: '削除キーを押して削除'
    },
    uploadPro: {
      tip1: 'Websocket接続が切断されました。再接続を試みています',
      tip2: '接続が切断されました'
    },
    select: {
      jiazaizhong: '読み込み中',
      wupipeishuju: '一致するデータがありません',
      wushuju: 'データなし',
      quanxuan: 'すべて選択',
      fanxuan: '選択を反転'
    },
    transfer: {
      tip1: '検索',
      liebiao1: 'リスト1',
      liebiao2: 'リスト2'
    },
    treeGrid: {
      caozuolan: '操作'
    },
    empty: {
      zanwuneirong: 'データなし'
    },
    valid: {
      char: '文字',
      len1: '{p1}文字を入力してください',
      len2: '{p1}から{p2}文字を入力してください',
      num: '数字',
      pInt: '正の整数',
      npInt: '非正の整数',
      nInt: '負の整数',
      nNInt: '非負の整数',
      int: '整数',
      pFNum: '正の浮動小数点数',
      nFNum: '負の浮動小数点数',
      num_: '数字(-,_)のみ',
      en: '英字',
      en_: '英字(-,_)のみ',
      ch: '中国語文字',
      ch_: '中国語文字(-,_)のみ',
      nch: '中国語以外の文字',
      numEn: '数字または英字',
      numEn_: '数字または英字(-,_)のみ',
      chEnNum: '数字、英字、または中国語文字',
      chEnNum_: '数字、英字、または中国語文字(-,_)のみ',
      phone: '電話番号形式',
      email: 'メール形式',
      idcard: '身分証明書形式',
      url: 'URL形式',
      reg: '正しい形式で入力してください',
      version: 'バージョンタグ',
      uri: 'URI',
      datasource: 'データソース',
      intRegion: '{p1}から{p2}の整数を入力してください',
      floatRegion: '{p1}から{p2}の浮動小数点数を入力してください'
    },
    timerange: {
      jue_dui_shi_jian_fan_wei: '絶対時間範囲',
      xiang_dui_shi_jian_fan_wei: '相対時間範囲',
      kai_shi_shi_jian: '開始時間',
      jie_su_shi_jian: '終了時間',
      zui_jin_wu_fen_zhong: '過去5分間',
      zui_jin_shi_wu_fen_zhong: '過去15分間',
      zui_jin_san_shi_fen_zhong: '過去30分間',
      zui_jin_yi_xiao_shi: '過去1時間',
      zui_jin_san_xiao_shi: '過去3時間',
      zui_jin_liu_xiao_shi: '過去6時間',
      zui_jin_shi_er_xiao_shi: '過去12時間',
      zui_jin_er_shi_si_xiao_shi: '過去24時間',
      zui_jin_liang_tian: '過去2日間',
      zui_jin_qi_tian: '過去7日間',
      zui_jin_san_shi_tian: '過去30日間'
    },
    bookmark: {
      biao_ti: 'ブックマーク',
      xin_zeng_shu_qian: 'ブックマークを追加',
      ming_cheng: '名前',
      fu_gai: '上書き',
      chong_ming_ming: '名前変更',
      shan_chu: '削除',
      ming_cheng_xiu_gai_cheng_gong: '名前が正常に変更されました',
      xin_zeng: '追加',
      shan_chu_ti_shi: '[{name}]を削除してもよろしいですか？',
      shan_chu_cheng_gong: '正常に削除されました',
      xin_zeng_cheng_gong: 'ブックマークが正常に追加されました！',
      tian_jia_ji_lu: '履歴に追加',
      gong: '合計',
      tiao: '件',
      bao_cun: '保存',
      qing_wan_cheng_zheng_zai_tian_jia_xiang: '追加中のレコードを確認してください'
    },
    messageBox: {
      qing_shuru_yanzhengma: '認証コードを入力してください',
      yanzhengma_bu_zhengque: '認証コードが正しくありません'
    },
    jsonEditor: {
      fuzhi: 'コピー'
    },
    cron: {
      second: '秒',
      minute: '分',
      hour: '時',
      day: '日',
      month: '月',
      week: '週',
      year: '年',
      cron_biaodashi_ziduan: 'Cron式フィールド',
      hanhua_fanyi: '日本語訳',
      chongzhi: 'リセット',
      single: '毎 ',
      mei_nian: '毎年',
      mei_yue: '毎月',
      mei_ri: '毎日',
      mei_tian: '毎日',
      mei_shi: '毎時',
      xiaoshi: '時',
      mei_fenzhong: '毎分',
      mei_miao: '毎秒',
      mei_zhou: '毎週',
      cong: 'から',
      yue_qi_mei_ge: '毎月',
      ri_qi_mei_ge: '毎日',
      shi_qi_mei_ge: '毎時',
      fenzhong_qi_mei_ge: '毎分',
      miao_qi_mei_ge: '毎秒',
      zuihou_yitian: '最終日',
      zhi: 'まで',
      cong_zhou: '週から',
      zhi_zhou: '週まで',
      qi_meige: '毎',
      tian_zhixingyici: ' 1日1回実行',
      xiaoshi_zhixingyici: ' 1時間に1回実行',
      yue_zhixingyici: ' 1ヶ月に1回実行',
      zhixingyici: ' 1回実行',
      ben_yue_di: '今月の',
      ben_yue: '今月',
      xinqi: '週',
      benyue_zuihou_yige_xingqi: '月の最後の週',
      buzhiding: '指定なし',
      zhouqi_cong: 'サイクル開始',
      xunhuan_cong: 'ループ開始',
      tip1: '毎日',
      tip2: '最も近い営業日',
      tip3: '開始、毎時 ',
      tip4: '開始、毎月',
      tip5: '週の曜日',
      benyue_zuihou_yitian: '月の最終日',
      zhiding: '指定',
      kaishi: '開始',
      kaishi_mei: '開始毎',
      benyue: '今月',
      mei: '毎 ',
      zhixing: '実行',
      zhouqi: 'サイクル',
      di: '第',
      mess1: '日付と週を同時に「指定なし」にすることはできません',
      mess2: '日付と週のいずれかは「指定なし」である必要があります',
      zhouri: '日曜日',
      zhouyi: '月曜日',
      zhouer: '火曜日',
      zhousan: '水曜日',
      zhousi: '木曜日',
      zhouwu: '金曜日',
      zhouliu: '土曜日'
    },
    treeGraph: {
      fangda: '拡大',
      suoxiao: '縮小',
      shuaxin: '更新'
    }
  }
} 


// WEBPACK FOOTER //
// ./src/components/SimbartUI/lang/ja-JP.js